import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps } from 'src/Library/Types';
import Loader from 'src/components/common/Loader';
import Navbar from 'src/components/navbar/Navbar';
import { useGenericState } from 'src/Library/UseGenericState';
import { Button, Col, Modal, Select, Spin, Table, Tag , Icon, Tooltip, message, Menu, Dropdown, Checkbox, Form } from 'antd';
import GetExecutionData from 'src/dto/response/getExecution';
import { getShipmentPicDetails, postBulkUpdateShipment, searchShippingApi, updateShipmentPicDetails } from 'src/api/shipmentExecution';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bulkUpdatesearchFilterOptions, bulkUploadTabs, MAX_PIC_ASSIGNMENTS } from './SE.constants';
import { SEFiltersType, ShipmentSearchDropDown } from './SE.Types';
import { fetchAllTeams } from 'src/api/teams';
import { isValidArray } from 'src/Library/Helper';
import SEBulkUpdate from './SEBulkUpdate';
import { REQUEST_STATUS } from '../BulkRequest/BulkRequestUtils';
import { buttonStyle } from 'src/Library/CommonStyles';
import { UserRole , OrgTypes } from 'src/Library/Constants';
import { set } from 'lodash';

const styles = () => ({
  modalDiv: {
    width: '100% !important',
    height: '100% !important',
    top: 0,
    paddingBottom: 0,
    minWidth: '1080px',
    '& .ant-modal-header': {
      padding: '0',
    },
    '& .ant-modal-content': {
      height: '100%',
    },
  },
  tabButtonStyle: {
    borderLeftWidth: '1px',
    borderRadius: '0',
    width: '150px',
    borderColor: '#d9d9d9',
    color: null,
  },
  selectedTabButtonStyle: {
    borderColor: '#016FC3',
    color: '#016FC3',
    borderRadius: '0',
    width: '150px',
  },
  pageHeaderStyles: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 16px',
    background: '#FFFFFF',
    borderBottom: '1px solid #cccccc',
  },
  cancelButton: {
    backgroundColor: '#fff',
    color: '#000',
    border: '1px solid #ccc',
    borderRadius: '4px',
    textShadow: 'none',
    marginRight: '15px',
  },
  
  submitButton: {
    ...buttonStyle('#FFFFFF', '#006EC3', '1px solid #006EC3'),
    padding: '0px 10px',
    borderRadius: '4px',
    marginLeft: '5px',
    backgroundColor: '#016FC3',
    border: '#016FC3',
  },
  submitButtonDisabled: {
    ...buttonStyle('#FFFFFF', '#CCCCCC', '1px solid #CCCCCC'),
    padding: '0px 10px',
    borderRadius: '4px',
    marginLeft: '5px',
    cursor: 'not-allowed',
  },
  searchTypeFilter: {
    width: '232px',
    height: '30px',
    '& .ant-select-selection--single': {
      borderRadius: '4px 0px 0px 4px',
    },
  },
  searchAssigneeFilter: {
    width: '100%',
    height: '30px',
  },
  search: {
    '& .ant-select-selection--single': {
      borderRadius: '0px 4px 4px 0px',
    },
    '& .ant-select-selection--multiple .ant-select-selection__clear': {
      marginRight: '10px',
      width: '400px',
      borderRadius: '0 4px 4px 0',
      height: '100%',
      overflowY: 'scroll',
    },
    width: '232px',
    height: '30px',
    '& .ant-select-selection__placeholder': {
      fontSize: '13px !important',
    },
  },
  AddPicBtn: {
    width: '250px',
    border: 'none',
    color: '#3089CE',
    textAlign: 'left',
    padding: '0',
    fontWeight: '0',
    boxShadow: 'none',
  },
  AddAssignmentBtn: {
    width: '250px',
    border: 'none',
    color: '#3089CE',
    textAlign: 'left',
    padding: '0',
    margin: '20px 0',
    fontWeight: '0',
    boxShadow: 'none',
    marginLeft: '40px',
  },
});

interface IProps extends StylesProps<ReturnType<typeof styles>> {
    onBack: (params: any) => void;
    getRequestObject: (params: any) => void;
    type: string;
    selectedShipments: Record<string, GetExecutionData>;
    userRole: UserRole;
    appliedFilters: SEFiltersType;
    loadSelectedShipments: boolean;
    orgType: string;
    organisationId: string;
}

interface StateProps {
  currentTab: string;
  dropdown: ShipmentSearchDropDown[];
  isSearching: boolean;
  PicData: any[];
  teamsData: any[];
  isLoading: boolean;
  isPicUpdateLoading: boolean;
  isErrorModalVisible: boolean;
  errorData: any[];
  organisationId: string;
}

const SEBulkUpdateModal = (props: IProps) => {

  const [state, setState] = useGenericState<StateProps>({
    currentTab: bulkUploadTabs.PIC_ASSIGNMENT,
    dropdown: [],
    isSearching: false,
    PicData: [],
    teamsData: [],
    isLoading: false,
    isPicUpdateLoading: false,
    isErrorModalVisible: false,
    errorData: [],
    organisationId: props.organisationId,
  });

  const {
    currentTab,
    dropdown,
    isSearching,
    PicData,
    teamsData,
    isLoading,
    isPicUpdateLoading,
    isErrorModalVisible,
    errorData,
  } = state;

  const {
    onBack,
    getRequestObject,
    classes,
    type,
    selectedShipments,
    userRole,
    appliedFilters,
    loadSelectedShipments,
    orgType,
  } = props;

  const defaultSearchType = 'CLIENT REF #';
  const searchInputRef = React.useRef<any>(null);
  const [updateRequest, setUpdateRequest] = React.useState<undefined | {
    fileName: string,
    id: string | number,
    status: REQUEST_STATUS,
  }>(undefined);
  const [s3UploadMap, setS3UploadMap] = React.useState<any[]>([])
  const [isExcelUploading, setIsExcelUploading] = React.useState<boolean>(false);
  const [fileName, setFileName] = React.useState<string>('');
  const isAdmin = userRole === UserRole.ADMIN && orgType === OrgTypes.SHIPPER;
  const isSubmitDisabled = (!s3UploadMap?.length&& state.currentTab === bulkUploadTabs.CONTAINER_FIELDS) || (state.currentTab === bulkUploadTabs.PIC_ASSIGNMENT && !isAdmin);
  const [shipmentID, setShipmentID] = React.useState<string[]>([]);
  const emptyPicData = {
    searchType: defaultSearchType,
    searchFilterValue: undefined,
    shipmentId: undefined,
    assignees: [
      {
        assignee: undefined,
        team: undefined,
      },
    ],
  };
  let timeout: any = null;  

  React.useEffect(() => {
    if (!isAdmin){
      setState({currentTab: bulkUploadTabs.CONTAINER_FIELDS});
    }
    setInitialData();
  }, []);

  const setInitialData = async () => {
    setState({ isLoading: true });
    await getTeamsData();
    if (loadSelectedShipments){
      await setSelectedShipmentsData();
    } else {
      setState({PicData: [emptyPicData]})
    }
    setState({isLoading: false});
  }

  const getTeamsData = async () => {
    const response = await fetchAllTeams({ adminRestriction: true, getAllTeams: true });
    const filteredTeams = response?.data?.filter(team => team.organisationId === props.organisationId);
    setState({teamsData: getKeyLabelUsersFromArray(filteredTeams)})
  };

  const setSelectedShipmentsData = async () => {
    const currentPicData: any[] = [];
    for (const shipment of Object.values(selectedShipments)) {
      setShipmentID(prevState => [...prevState, shipment.id]);
      const index = currentPicData.length;
      if (shipment.clientReferenceNumber) {
        currentPicData.push({
          searchType: defaultSearchType,
          searchFilterValue: shipment.clientReferenceNumber,
          shipmentId: shipment.id,
        });
      } else if (shipment.referenceNumber) {
        currentPicData.push({
          searchType: 'SHIPMENT #',
          searchFilterValue: shipment.referenceNumber,
          shipmentId: shipment.id,
        });
      }
      const response = await getShipmentPicDetails(shipment.id);
      if (response?.isSuccess) {
        const currentAssignees = response?.data?.picData.map((pic) => {
          return {
            team: pic?.teamId,
            assignee: pic?.userId,
          };
        });
        currentAssignees.push({ team: undefined, assignee: undefined })
        currentPicData[index].assignees = currentAssignees;
      }
    }

    !currentPicData.length && currentPicData.push(emptyPicData);
    setState({ PicData: currentPicData });
  };

  
  const getKeyLabelUsersFromArray = (inputArray) => {
    if (!isValidArray(inputArray)) return [];
    return inputArray.map(item => ({
      key: item.id,
      label: item.name,
      users: item.users,
    }));
  }

  const renderNavbar = () => {
    return <Navbar
      pageTitle="Bulk Update"
      shouldDisplayBack={true}
      alwaysShowBack={true}
      handleBack={onBack}
    />;
  };

  const renderTabs = () => {
    return (
      <div>
        {
          isAdmin && 
          <Button className={currentTab === bulkUploadTabs.PIC_ASSIGNMENT ? classes.selectedTabButtonStyle :classes.tabButtonStyle}
          onClick={() => setState({ currentTab: bulkUploadTabs.PIC_ASSIGNMENT })}
        >
          {bulkUploadTabs.PIC_ASSIGNMENT}
        </Button>
        }
        <Button className={currentTab === bulkUploadTabs.CONTAINER_FIELDS ? classes.selectedTabButtonStyle :classes.tabButtonStyle}
          onClick={() => setState({ currentTab: bulkUploadTabs.CONTAINER_FIELDS })}
        >
          { bulkUploadTabs.CONTAINER_FIELDS }
        </Button>
      </div>
    )
  }

  const handleSubmitLinks = async () => {
    if (!s3UploadMap?.length) {
      message.error('Please Upload a file');
      return;
    }
    setIsExcelUploading(true);
    const getLinks = s3UploadMap;
    const payload = {
      awsUrl: getLinks?.pop(),
      fileName,
    };
    const response = await postBulkUpdateShipment(payload);
    if (response.isSuccess) {
      if (response?.data?.failureArray?.length) {
        const errorArray = response?.data?.failureArray
        setState({
          errorData: errorArray
        });
        setState({isErrorModalVisible: true});
        return;
      } else {
        message.success('Tasks(s) updated successfully.');
        // setShowBulkModel(false);

        getRequestObject({
          fileName,
          id: response.data?.data?.requestId,
          status: REQUEST_STATUS.PENDING,
        })
      } 

    } else {
      if (response?.data?.failureArray?.length) {
        setState({
          errorData: response?.data?.failureArray?.length
        })
        setState({isErrorModalVisible: true});
      } else if (response?.errorMessage) {
        message.error(response?.errorMessage);
      }
    }
    setIsExcelUploading(false);
  }

  const handleUpdatePIC = async () => {
    setState({ isPicUpdateLoading: true});
    const picDetails: any[] = [];
    if (PicData.some((data) => data.shipmentId === undefined)){
      message.error('Please select a shipment for all assignments');
      setState({ isPicUpdateLoading: false});
      return;
    } else if (PicData.length === 0){
      message.error('No Shipments to update');
      setState({ isPicUpdateLoading: false});
      return;
    }
    PicData.forEach(async (data, index) => {
      const { shipmentId } = data;
      const assignees: any[] = [];
      data.assignees.forEach((currentAssignee) => {
        if (currentAssignee.team && currentAssignee.assignee) {
          assignees.push({
            teamId: currentAssignee.team,
            userId: currentAssignee.assignee,
          });
        }
      });
      picDetails.push({
        shipmentId: shipmentId,
        picData: assignees,
      });
    });
    
    const response = await updateShipmentPicDetails({ picDetails });
    if (response?.isSuccess) {
      message.success('PIC updated successfully.');
      onBack({isSuccess: true});
    } else {
      message.error(response?.errorMessage);
    }
    setState({ isPicUpdateLoading: false});
  };

  const handleCancel = () => {
    onBack({});
  }

  const handleSubmit = async () => {
    if (currentTab === bulkUploadTabs.PIC_ASSIGNMENT) {
      await handleUpdatePIC();
    } else if (currentTab === bulkUploadTabs.CONTAINER_FIELDS) {
      await handleSubmitLinks();
      onBack({});
    }
  };

  const renderActionButtons = () => {
    return (
      <div>
        <Button className={classes.cancelButton} onClick={()=> handleCancel()}>Cancel</Button>
        <Button
          className={isSubmitDisabled ? classes.submitButtonDisabled : classes.submitButton}
          loading={ isPicUpdateLoading || (isExcelUploading && currentTab === bulkUploadTabs.CONTAINER_FIELDS)}
          onClick={()=> handleSubmit()}
        >
          {currentTab === bulkUploadTabs.PIC_ASSIGNMENT ? 'Update PIC' : 'Upload'}
        </Button>
      </div>
    );
  };

  const renderPageHeader = () => {
    return (
      <div className={classes.pageHeaderStyles}>
        {renderTabs()}
        {renderActionButtons()}
      </div>
    )
  }
  const renderbulkUpdateModal = () => {
    return (
      <SEBulkUpdate
        filters={appliedFilters}
        type={type}
        getRequestObject={(params) => setUpdateRequest(params)}
        s3UploadMap={s3UploadMap}
        setS3UploadMap={setS3UploadMap}
        isLoading={isExcelUploading}
        setIsLoading={setIsExcelUploading}
        isErrorModalVisible={isErrorModalVisible}
        errorData={errorData}
        fileName={fileName}
        setFileName={setFileName}
        selectedDocuments={shipmentID}
      />
    )
  }

  const handleShipmentSearchType = (value, index) => {
    setState({dropdown: []})
    const currentPICData = PicData;
    currentPICData[index].searchType = value;
    currentPICData[index].searchFilterValue = undefined;
    currentPICData[index].shipmentId = undefined;
    setState({PicData: currentPICData});
  }

  const searchShipment = async (search, searchType) => {
    if (!isSearching) {
      setState({isSearching: true})
    }
    const apiCallObject = {
      queryString: search,
      viewType: type === 'SHIPPER' ? 'SHIPPER' : 'VENDOR',
      searchType: searchType,
    }
    const response: any = await searchShippingApi(apiCallObject);
    if (response.isSuccess) {
      setState({
        isSearching: false,
        dropdown: response.data,
      })
    }
    setState({isSearching: false})
  };

  const handleShipmentChange = async (search, option, index) => {
    const currentPICData = PicData;
    if (search){
      const shipmentId = option?.props?.shipmentIdList[0];
      const response = await getShipmentPicDetails(shipmentId);
      if (response?.isSuccess){
        currentPICData[index].searchFilterValue = option?.props?.name;
        currentPICData[index].shipmentId = option?.props?.shipmentIdList[0];
        const currentAssignees = response?.data?.picData.map((pic) => {
          return {
            team: pic?.teamId,
            assignee: pic?.userId,
          }
        })
        currentPICData[index].assignees = currentAssignees;
        currentPICData[index].assignees.push({team: undefined, assignee: undefined});
      } else {
        currentPICData[index].searchFilterValue = undefined;
        currentPICData[index].shipmentId = undefined;
        message.error(response?.errorMessage);
      }
    } else {
      currentPICData[index].searchFilterValue = undefined;
    }
    setState({PicData: currentPICData})
  };

  const handleShipmentSearch = (val, searchType) => {
    if (val.length) {
      if (timeout) {
        clearTimeout(timeout);
      }
      setState({isSearching: true})
      timeout = setTimeout(() => {
        searchShipment(val, searchType);
      }, 200);
    } else {
      timeout && clearTimeout(timeout);
      setState({dropdown: []})
    }
  };

  const handleChangeAssignedTeam = (value, index, assigneeIndex) => {
    const currentPICData = PicData;
    currentPICData[index].assignees[assigneeIndex].team = value;
    currentPICData[index].assignees[assigneeIndex].assignee = undefined;
    setState({PicData: currentPICData})
  }

  const getUsersFromTeamData = ( id ) => {
    const usersData = teamsData.find(item => item.key === id);
    return usersData?.users;
  }

  const getTeamNameFromId = ( id ) => {
    const teamData = teamsData.find(item => item.key === id);
    return teamData?.label;
  }

  const getUserNamefromUserId = ( id ) => {
    const usersData = teamsData.find(item => item.users.find(user => user.id === id));
    const userData = usersData?.users.find(user => user.id === id);
    return userData?.name;
  }

  const handleChangeAssignedUser = (value, index, assigneeIndex) => {
    const currentPICData = PicData;
    currentPICData[index].assignees[assigneeIndex].assignee = value;
    setState({PicData: currentPICData})
  }

  const renderAssignees = (data, index, assigneeIndex) => {
    const teamId  = data?.assignees[assigneeIndex]?.team;
    const usersDropdown = getUsersFromTeamData(teamId);
    return (
      <div style={{ width: '100%' }}>
        <Col span={7}>
          <Select
            mode="default"
            value={getTeamNameFromId(data?.assignees[assigneeIndex]?.team)}
            className={classes.searchAssigneeFilter}
            onChange={(value) => handleChangeAssignedTeam(value, index, assigneeIndex)}
            placeholder={'Select Team'}
          >
            {teamsData.map((team) => (
              <Select.Option key={team.key} value={team.key}>
                {team.label}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col span={10} style={{marginLeft: '10px'}}>
          <Select
            mode="default"
            value={getUserNamefromUserId(data?.assignees[assigneeIndex]?.assignee)}
            className={classes.searchAssigneeFilter}
            onChange={(value) => handleChangeAssignedUser(value, index, assigneeIndex)}
            placeholder={'Select Assignee'}
          >
            {usersDropdown?.map((user) => (
              <Select.Option key={user.id} value={user.id}>
                {user.name}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <div
          style={{
            color: '#EC4621',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '15px',
            height: '100%',
          }}
        >
          <Icon type="delete" onClick={() => deleteAssignee(index, assigneeIndex)} />
        </div>
      </div>
    );
  }

  const deleteAssignee = (index, assigneeIndex) => {
    const currentPICData = PicData;
    currentPICData[index].assignees.splice(assigneeIndex, 1);
    if (currentPICData[index].assignees.length === 0){
      currentPICData.splice(index, 1);
    }
    setState({PicData: currentPICData})
  }

  const renderPICData = (data, index) => {
    const { searchType, searchFilterValue } = data;
    return data?.assignees?.map((assignee, assigneeIndex) => {
      return (
        <div style={{ fontSize: 20, cursor: 'pointer' , display: 'flex', flexDirection: 'row', margin: '10px 0'}}>
          {
            <Col span={3}> <span style={{fontSize: '14px', paddingLeft:'40px'}}>{assigneeIndex === 0 ? `Assignment ${index + 1}` : ''} </span> </Col>
          }
          { 
            <Col span={8} style={{ display: 'flex'}}>
              <Select
                disabled={assigneeIndex>0}
                mode="default"
                onChange={(value) => handleShipmentSearchType(value, index)}
                defaultValue={searchType}
                value={searchType}
                className={classes.searchTypeFilter}
                id={'searchTypeFilter'}
              >
                {bulkUpdatesearchFilterOptions.map((item) => (
                  <Select.Option key={item.key} value={item.key}>
                    <Tooltip
                      title={item.label}
                      placement={'left'}
                      data-search-type-name={item?.label}
                    >
                      {item.label}
                    </Tooltip>
                  </Select.Option>
                ))}
              </Select>
              <Select
                disabled={assigneeIndex>0}
                getPopupContainer={(trigger: any) => trigger.parentNode}
                showSearch
                allowClear
                dropdownMatchSelectWidth={false}
                filterOption={(inputValue, option) => true}
                notFoundContent={
                  isSearching ? (
                    <div style={{ padding: '25px' }}>
                      <Spin />
                    </div>
                  ) : (
                    'Not Found'
                  )
                }
                suffixIcon={<Icon type="search" />}
                className={classes.search}
                placeholder={'Search'}
                value={searchFilterValue}
                onFocus={() => searchShipment(searchFilterValue, searchType)}
                onChange={(value, option) => handleShipmentChange(value, option, index)}
                onSearch={(val) => handleShipmentSearch(val, searchType)}
                dropdownMenuStyle={{ width: '300px' }}
                optionLabelProp={'data-value'}
                ref={searchInputRef}
              >
                {dropdown &&
                  dropdown.map((item: any) => (
                    <Select.Option {...item} key={item.id} data-value={item.name}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <div
                          style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {item.name}
                        </div>
                        <span></span>
                        <Tag color="cyan">{item.searchType}</Tag>
                      </div>
                    </Select.Option>
                  ))}
              </Select>
            </Col>
          }
          {renderAssignees(data, index, assigneeIndex)}
        </div>
      );
    });
  };

  const renderPicDetailsHeader = () => {
    return (
      <div style={{color:'#666666', fontSize:'12px', fontWeight: 500}}>
        <Col span={3}></Col>
        <Col span={8}>
          <span>Shipment Number</span>
        </Col>
        <Col span={3}>
          <span>Assigned Team</span>
        </Col>
        <Col span={3}>
          <span style={{ paddingLeft: '58px' }}>Assignee</span>
        </Col>
      </div>
    );
  };

  const addNewAssignment = () => {
    if (PicData.length === MAX_PIC_ASSIGNMENTS){
      message.error(`You can add a maximum of ${MAX_PIC_ASSIGNMENTS} assignments`);
      return;
    }
    const currentPICData = PicData;
    currentPICData.push({
      searchType: defaultSearchType,
      searchFilterValue: undefined,
      assignees: [
        {
          assignee: undefined,
          team: undefined,
        },
      ]
    });
    setState({PicData: currentPICData})
  }

  const addNewPic = (index) => {
    const currentPICData = PicData;
    currentPICData[index]?.assignees.push({
      assignee: undefined,
      team: undefined,
    });
    setState({PicData: currentPICData})
  }

  const renderAddPicButton = (index) => {
    return (
      <div>
        <Col span={3}></Col>
        <Col span={20} style={{borderBottom: '1px solid #cccccc', paddingBottom: '20px'}}>
          <Button
            onClick={() => addNewPic(index)}
            className={classes.AddPicBtn}
          >
            <span>+ Add PIC for another Team</span>
          </Button>
        </Col>
      </div>
    );
  };

  const renderPICDetails = () => {
    return (
      <div>
        {
          PicData.map((data, index) => {
            return (
              <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'column'}}>
                {renderPicDetailsHeader()}
                {renderPICData(data, index)}
                {
                  renderAddPicButton(index)
                }
              </div>
            )
          })
        }
        <Button
        onClick = {() => {
          addNewAssignment();
        }}
        className={classes.AddAssignmentBtn}
        >
          + Add New Assignment
        </Button>
      </div>
    )
  };

  return (
    <Modal
      visible={true}
      className={classes.modalDiv}
      closable={false}
      title={renderNavbar()}
      bodyStyle={{ color: '#111111' , padding: '0px', maxHeight: 'calc(100vh - 80px)', overflow: 'auto'}}
      footer={null}
    >
      {renderPageHeader()}
      {currentTab === bulkUploadTabs.PIC_ASSIGNMENT && isAdmin ? (
        isLoading ? <Loader zIndex={1}/> : renderPICDetails()
      ) : null}
      {currentTab === bulkUploadTabs.CONTAINER_FIELDS ? renderbulkUpdateModal() : null}
    </Modal>
  );
};

const mapStateToProps = ({ shipmentExecutionReducer, masterData }, ownProps) => ({
  selectedShipments: shipmentExecutionReducer.selectedShipments,
  appliedFilters: shipmentExecutionReducer.appliedFilters,
  userRole: masterData.userData.role,
  orgType: masterData.userData.type,
  organisationId: masterData.userData.organisation_id
});

const mapDispatchToProps = dispatch => (bindActionCreators({
}, dispatch));

export default connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles(styles)(Form.create()(React.memo(SEBulkUpdateModal))));